import { LazyAction, LazyBootModule } from 'owa-bundling-light';

const lazyModule = new LazyBootModule(
    () => import(/* webpackChunkName: "SharedBoot" */ './lazyIndex'),
    { name: 'SharedBoot' }
);

export const lazyFrameworkBootstrap = new LazyAction(lazyModule, m => m.appBootstrap);
